import Vue from 'vue'
import { store } from '../../components/front/vue/store/store'
// import UserRequest from 'FrontComponents/vue/UserRequest/Form.vue'

if (document.querySelector('#user-request')) {
    Vue.config.productionTip = false

    const UserRequest = () => import(/* webpackChunkName: "assets/user-request" */ 'FrontComponents/vue/UserRequest/Form.vue')

    let mixin = {
        methods: {
            route: route,
        },
    }

    // To force a hash version change
    console.log('user-requests.js loaded');

    /**
     * Then you can do stuff like this:
     *
     * {{ 'javascript.title.home' | trans }}
     * {{ 'javascript.title.welcome' | trans({ name: 'Nasirou' }) }}
     */
    Vue.filter('trans', (...args) => {
        return Lang.get(...args)
    })

    new Vue({
        el: '#user-request',
        store,
        mixins: [mixin],
        components: {
            UserRequest,
        },
    })
}
